import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'melp-design/components';
import { FileDownloadOutlined } from '@mui/icons-material';
import { formatDuration } from 'utils/format';
import moment from 'moment';

interface Props {
  listLength: number;
  loading: boolean;
  exportToExcel: () => void;
  limitedRange?: {
    limit: Parameters<typeof formatDuration>[1];
    unit: Parameters<typeof formatDuration>[2];
    dateFrom?: string;
    dateTo?: string;
  };
}

export const DownloadXlsAction: FC<Props> = ({
  exportToExcel,
  loading,
  listLength,
  limitedRange,
}) => {
  const { t, i18n } = useTranslation();
  const handleDownload = useCallback(() => {
    exportToExcel();
  }, [exportToExcel]);

  const isExportAvailable = !limitedRange
    ? true
    : !limitedRange.dateFrom
    ? false
    : Math.abs(
        moment(limitedRange.dateFrom).diff(
          moment(limitedRange.dateTo || new Date().toISOString()),
          limitedRange.unit,
        ),
      ) >= limitedRange.limit
    ? false
    : true;

  return (
    <Button
      label={t('dashboard.download_xls')}
      size="sm"
      variant="neutral-outline"
      icon={FileDownloadOutlined}
      onClick={handleDownload}
      disabled={!listLength || loading || !isExportAvailable}
      tooltip={
        !limitedRange || isExportAvailable
          ? undefined
          : t('common.export.limited_range', {
              range: formatDuration(
                i18n.language,
                limitedRange.limit,
                limitedRange.unit,
              ),
            })
      }
    />
  );
};
